import Transports from './transports';

export default class Console implements Transports {
  debug(...args): void {
    console.debug(...args);
  }

  error(...args): void {
    console.error(...args);
  }

  info(...args): void {
    console.info(...args);
  }

  warning(...args): void {
    console.warn(...args);
  }
}
